import React from 'react';
import { Icon } from 'js/components';
import { Card, CardBody, Button } from 'reactstrap';

function NoProductManagersCard({ type = 'default', onAddProductManager }) {
  return (
    <Card>
      <CardBody>
        {type === 'archived' ? (
          <div className="media text-muted mt-4 mb-4">
            <Icon
              icon={['fal', 'spider-web']}
              size="4x"
              className="mr-3"
              fixedWidth
            />
            <div className="media-body">
              <p>You don't have any archived product managers.</p>
              <p>
                Archiving a product manager suspends it from your account while
                preserving its connections for historical purposes. We recommend
                archiving product managers you no longer use to keep your
                account tidy.
              </p>
            </div>
          </div>
        ) : (
          <div className="media text-muted mt-4 mb-4">
            <Icon
              icon={['far', 'star-exclamation']}
              size="4x"
              className="mr-3"
              fixedWidth
            />
            <div className="media-body">
              <p>You don't have any active product managers.</p>

              <div>
                <Button
                  data-test="create-team-link"
                  color="primary"
                  className="create-link"
                  onClick={onAddProductManager}
                >
                  <Icon icon="plus" className="btn-icon-left" /> Create a new
                  product manager
                </Button>
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default NoProductManagersCard;
